import { get as _get } from 'lodash';
import cookie from 'react-cookie';
import {
  fetchWindWave,
  fetchForecasts,
  fetchWrittenForecasts,
} from '../common/api/forecast';
import { fetchNearbyRegionByCoordinates } from '../common/api/cms';
import { lotusOrLola } from '../common/forecast';
import { NOT_FOUND, INTERNAL_SERVER_ERROR } from './status';
import forecastTransform from '../utils/forecasts/forecastTransform';
import { getUserLegacySettings, getUserBwWindWaveModel, getUserBwUnitPreference, getUserLocation } from '../selectors/user';

export const FETCH_FORECAST = 'FETCH_FORECAST';
export const FETCH_FORECAST_SUCCESS = 'FETCH_FORECAST_SUCCESS';
export const FETCH_FORECAST_FAILURE = 'FETCH_FORECAST_FAILURE';
export const FORECAST_PRINT_VERSION = 'FORECAST_PRINT_VERSION';

export const fetchForecast = (coordinates, interval = 180) => async (dispatch, getState) => {
  dispatch({
    type: FETCH_FORECAST,
  });
  try {
    const legacyUserSettings = getUserLegacySettings(getState());
    const bwWindWaveModel = getUserBwWindWaveModel(getState());
    const bwUnitPreference = getUserBwUnitPreference(getState());
    const userStateDetails = _get(getState(), 'user.details', {});
    const { countryCode: ipCountry, cfIPCountry } = getUserLocation(getState());
    const countryCode = cfIPCountry || ipCountry;
    const { forecast: { printVersion } } = getState();
    const [lat, lon] = coordinates;
    let forecast = {};

    if (lotusOrLola(bwWindWaveModel)) {
      const newWrittenForecast = await fetchWrittenForecasts(lat, lon, bwWindWaveModel, bwUnitPreference, userStateDetails, countryCode);
      const newDataForecast = await fetchForecasts(lat, lon, bwWindWaveModel, interval, bwUnitPreference, userStateDetails, countryCode);

      forecast = forecastTransform(
        newDataForecast,
        newWrittenForecast,
        legacyUserSettings,
        printVersion,
      );
    } else {
      const nearbyRegion = await fetchNearbyRegionByCoordinates(coordinates);
      const grb = nearbyRegion && nearbyRegion.region_model_grb ? nearbyRegion.region_model_grb : 'enp';
      forecast = await fetchWindWave(lat, lon, bwWindWaveModel, grb, userStateDetails);
    }

    await dispatch({
      type: FETCH_FORECAST_SUCCESS,
      forecast,
      interval,
    });
  } catch (error) {
    console.error(error);
    dispatch({
      type: FETCH_FORECAST_FAILURE,
      error: error.message,
    });

    if (error.statusCode >= 400 && error.statusCode < 500) {
      dispatch({
        type: NOT_FOUND,
        message: `Forecast for ${coordinates} could not be found`,
      });
    } else {
      dispatch({
        type: INTERNAL_SERVER_ERROR,
        message: `Forecast for ${coordinates} error`,
      });
    }
  }
};

export const isForecastPrintVersion = printVersion => async (dispatch) => {
  dispatch({ type: FORECAST_PRINT_VERSION, printVersion });
};



// WEBPACK FOOTER //
// ./src/actions/forecast.js